import { Collapsible } from '@app/components/Collapsible';

import Content from './Content';
import Summary from './Summary';

import styles from './index.module.scss';

const CollapsibleDisconnectCart = () => {
  return (
    <Collapsible
      dataCy="collapsible-disconnection-cart"
      classNames={{ summary: styles['summaryBackground'] }}
      summary={<Summary />}
      content={<Content />}
    />
  );
};

export default CollapsibleDisconnectCart;
